import { Routes, Route, Navigate } from "react-router-dom";
import HomePage from "../pages/HomePage";
import Login from "../pages/LoginPage";
import Signup from "../pages/SignUpPage";
import AppointmentPage from "../pages/appointment/AppointmentPage";
import DoctorProfilePage from "../pages/profiles/DoctorProfile";
import EmergencyPage from "../pages/emergency/EmergencyPage";
import BookingTracker from "../pages/track_booking/TrackBooking";
import DoctorDashboard from "../pages/dashboard/DoctorDashboard";
import PatientListPage from "../pages/patients_list/PatientsList";
import DoctorBookingPage from "../pages/bookings/DoctorBookingList";
import LogOut from "../pages/logout/LogoutPage";
import { useContext } from "react";
import { BaseAppContext } from "../utils/context";
import { UserRole } from "../models/enums/UserRoleEnum";
import PatientDashboard from "../pages/dashboard/PatientDashboard";
import Leaves from "../pages/Leaves";

const AppRoutes = () => {
  const { isLoggedIn, loggedUserRole } = useContext(BaseAppContext);
  const renderDashboard = () => {
    if (loggedUserRole === UserRole.Doctor) return <DoctorDashboard />;
    if (loggedUserRole === UserRole.Patient) return <PatientDashboard />;
    return <Navigate to="/login" replace />;
  };
  return (
    <Routes>
      {!isLoggedIn ? (
        <>
          <Route path="/" element={<HomePage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
        </>
      ) : (
        <>
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/login" element={<Navigate to="/dashboard" replace />} />
          <Route
            path="/signup"
            element={<Navigate to="/dashboard" replace />}
          />
        </>
      )}
      <Route path="/" element={<HomePage />} />
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/appointment" element={<AppointmentPage />} />
      <Route path="/profile" element={<DoctorProfilePage />} />
      <Route path="/emergency" element={<EmergencyPage />} />
      <Route path="/dashboard" element={renderDashboard()} />
      <Route path="/track-bookings" element={<BookingTracker />} />
      <Route path="/patients" element={<PatientListPage />} />
      <Route path="/booking" element={<DoctorBookingPage />} />
      <Route path="/logout" element={<LogOut />} />
       <Route path="/Leaves" element={<Leaves/>} />
    </Routes>
  );
};

export default AppRoutes;
